<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório quantitativo de dispensação">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/relatorio-quantitativo-dispensacao/List'

export default {
    components: { List },
}
</script>